import { render, staticRenderFns } from "./RequestFormView.vue?vue&type=template&id=8aa84414&"
import script from "./RequestFormView.vue?vue&type=script&lang=ts&"
export * from "./RequestFormView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8aa84414')) {
      api.createRecord('8aa84414', component.options)
    } else {
      api.reload('8aa84414', component.options)
    }
    module.hot.accept("./RequestFormView.vue?vue&type=template&id=8aa84414&", function () {
      api.rerender('8aa84414', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/RequestFormView.vue"
export default component.exports